import { PhoneNumber } from "./models";

export interface PhoneNumberValidation {
  regex: RegExp;
  message: string;
}
export const phoneNumberValidationRegex: Record<string, PhoneNumberValidation> =
  {
    // 10 digits without leading zeroes
    "27": {
      regex: /^0[0-9]{9}$/,
      message: "Must be 10 digits and start with 0",
    },
  };

export function validatePhoneNumber(phoneNumber: PhoneNumber): string | null {
  const isd = phoneNumber.isd;
  const number = phoneNumber.number;
  if (!isd || !number) {
    return "Required";
  }
  const validation = phoneNumberValidationRegex[isd];
  const regex = validation?.regex;
  if (regex && !regex.test(number)) {
    return validation.message;
  }
  return null;
}
